import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  AvatarEmpty,
  BasicFlex,
  Button,
  DatePicker,
  Delete,
  Edit,
  FilePresent,
  GeneralCardComponent,
  LabelValue,
  PageTitleAndSubTitle,
  Processing,
  RightPanelClose,
  Send,
  TextField,
  TypableDropdown,
  Upload,
  UploadedDocument,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import ticketManagementConstants from '../../../core-utils/messages/TicketManagementConstants';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import { NewTicketData } from '../NewTicketModal';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import moment from 'moment';
import { UserAccessConstants } from '../../../core-utils/helper-utils/userAccess';
import {
  formatFileSize,
  getAvatarComponent,
  getAvatarIcon,
  getChipComponent,
  getPriorityIcon,
} from '../../../core-utils/helper-utils/TaskBoardHelper';
import properties from '../../../core-utils/properties';
import axios from 'axios';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import { useStores } from '../../../stores';
import { formatDate } from '../../../core-utils/helper-utils/helper';

export interface TicketDetailsWindowProps {
  ticketId: string;
  setDeletePopUpOpen: any;
  setDetailsWindowOpen: any;
  ticketDetails: any;
  role: string;
   
  handleSave: (ticketId: string, data: any) => {};
  handleOpenSnackBar: any;
  assigneeOptions: any[];
  assigneeValues: any[];
}
const TicketDetailsWindow: React.FC<TicketDetailsWindowProps> = observer(
  ({
    ticketId,
    setDeletePopUpOpen,
    ticketDetails,
    role,
    handleSave,
    setDetailsWindowOpen,
    handleOpenSnackBar,
    assigneeOptions,
    assigneeValues,
  }) => {
    //constants
    const useStyles = makeStyles()({
      container: {
        width: '38.5%',
        background: patientAccessTheme.palette.status.white,
        margin: '30px 0px 20px 20px',
      },
      root: {
        minHeight: '427px',
        height: '640px',
        width: '100%',
        padding: '20px 0px 20px 20px',
        borderLeft: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        overflowY: 'auto',
        overflowX: 'hidden',
        flexWrap: 'nowrap',
        gap: '15px',
      },
      tools: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
      },
      iconStyle: {
        cursor: 'pointer',
        height: '24px',
        width: '24px',
      },
      flex: {
        display: 'flex',
        gap: '10px',
      },
      desc: {
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        padding: '4px',
        borderRadius: '4px',
        marginBottom: '20px',
      },
      scroll: {
        overflowY: 'scroll',
        ...scrollBarStyles,
      },
    });
    const { classes } = useStyles();
    const constants = ticketManagementConstants.DETAILS_MODAL;
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    //Stores
    const loginPageStore = useStores().loginPageStore;

    //State
    const [isDetailsEditing, setIsDetailsEditing] = useState<boolean>(false);
    const [isDescEditing, setIsDescEditing] = useState<boolean>(false);
    const [data, setData] = useState<NewTicketData>({
      issue: ticketDetails?.topic ?? '-',
      description: ticketDetails?.description ?? '-',
      platform: ticketDetails?.platform ?? '',
      type: ticketDetails?.type ?? '',
      priority: ticketDetails?.priority ?? '',
      dueDate: ticketDetails?.dueDate ?? '',
      assignee: ticketDetails?.assigneeId?.id ?? '',
      status: ticketDetails?.status ?? '',
      attachments: [],
    });
    const [comments, setComments] = useState<any>([]);
    const [newComment, setNewComment] = useState<any>('');
    const [isSending, setIsSending] = useState<boolean>(false);
    const [attachments, setAttachments] = useState<any>([]);
    const [isUploading, setIsUploading] = useState<boolean>(false);

    //functions
    const handleCancel = (fieldName: string) => {
      switch (fieldName) {
        case 'Description':
          setData((prevData) => ({
            ...prevData,
            description: ticketDetails?.description,
          }));
          setIsDescEditing(false);
        case 'Details':
          setData((prevData) => ({
            ...prevData,
            platform: ticketDetails?.platform,
            type: ticketDetails?.type,
            priority: ticketDetails?.priority,
            dueDate: ticketDetails?.dueDate,
            assignee: ticketDetails?.assigneeId?.id,
            status: ticketDetails?.status,
          }));
          setIsDetailsEditing(false);
        default:
          break;
      }
    };

    const handleChange = (event: any, fieldName: string) => {
      const value = event.target.value as string;
      setData((prevData) => ({
        ...prevData,
        [fieldName.toLowerCase()]: value,
      }));
    };

    const handleDueDateChange = (
       
      date: Date | null,
      value?: any,
    ) => {
      setData((prevData) => ({
        ...prevData,
        dueDate: value,
      }));
    };

    const handleButtonClick = () => {
      fileInputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        setIsUploading(true);
        const formData = new FormData();
        formData.append(`file`, file);
        formData.append('userId', loginPageStore.userId);
        axios
          .post(properties.aiqBaseUrl + properties.uploadAttachment, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res: any) => {
            if (res.status === 200) {
              addAttachmentDetails(res.data);
            }
          })
          .catch((error: any) => {
            handleOpenSnackBar('Upload Failed', 'error', 6000);
            throw error;
          });
      }
    };

    //Api Calls
    const getComments = async () => {
      await axios
        .get(
          properties.userManagementBaseUrl +
            properties.comments +
            properties.getCommentsByTicketId +
            `/${ticketId}`,
        )
        .then((res: any) => {
          if (res.status === 200) {
            setComments(res.data);
          }
        })
        .catch((err: any) => {
          handleOpenSnackBar('Fetching comments failed', 'error', 6000);
          throw err;
        });
    };

    const addNewComment = async () => {
      const reqBody = {
        commentText: newComment,
        ticketId: { ticketId: ticketId },
        commentedBy: { id: loginPageStore.userId },
      };
      await axios
        .post(
          properties.userManagementBaseUrl +
            properties.comments +
            properties.addComment,
          reqBody,
        )
        .then(async (res: any) => {
          if (res.status === 200) {
            getComments();
            setIsSending(false);
            setNewComment('');
          }
        })
        .catch((err: any) => {
          handleOpenSnackBar('Adding new comment failed', 'error', 6000);
          throw err;
        });
    };

    const getAttachments = async () => {
      await axios
        .get(
          properties.userManagementBaseUrl +
            properties.attachments +
            properties.getAttachmentsByTicketId +
            `/${ticketId}`,
        )
        .then((res: any) => {
          if (res.status === 200) {
            setAttachments(res.data);
          }
        })
        .catch((err: any) => {
          handleOpenSnackBar('Fetching attachments failed', 'error', 6000);
          throw err;
        });
    };

    const addAttachmentDetails = async (fileData: any) => {
      const reqBody = {
        fileUrl: fileData.fileUrl,
        fileName: fileData.fileName,
        fileMimeType: fileData.fileMimeType,
        fileSize: formatFileSize(fileData.fileSize),
        ticketId: { ticketId: ticketId },
        uploadedBy: { id: loginPageStore.userId },
      };
      await axios
        .post(
          properties.userManagementBaseUrl +
            properties.attachments +
            properties.addDetails,
          reqBody,
        )
        .then(async (res: any) => {
          if (res.status === 200) {
            await getAttachments();
          }
        })
        .catch((err: any) => {
          handleOpenSnackBar('Adding attachment details failed', 'error', 6000);
          throw err;
        });
      setIsUploading(false);
    };

    const deleteAttachment = async (attachmentId: string) => {
      handleOpenSnackBar('Attachment deletion in progress', 'info', '6000');
      axios
        .delete(
          properties.userManagementBaseUrl +
            properties.attachments +
            properties.deleteAttachment +
            `/${attachmentId}/${loginPageStore.userId}`,
        )
        .then((res: any) => {
          if (res.status === 200) {
            getAttachments();
            handleOpenSnackBar(
              'Attachment deleted successfully',
              'success',
              6000,
            );
          }
        })
        .catch((err: any) => {
          handleOpenSnackBar('Attachment deletion failed', 'error', 6000);
          throw err;
        });
    };

    const handleDownload = async (item: any) => {
      handleOpenSnackBar('File Download In Progress', 'info', 3000);
      await axios
        .post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.readFile,
          {
            documentUrl: item.fileUrl,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            const byteCharacters = atob(response.data?.data);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], { type: item.fileMimeType });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = item.fileName;
            link.click();
            handleOpenSnackBar('File Downloaded Successfully', 'success', 5000);
          }
        })
        .catch((error) => {
          handleOpenSnackBar('File Download Failed', 'error', 6000);
          throw error;
        });
    };

    //useEffects
    useEffect(() => {
      getComments();
      getAttachments();
    }, []);

    return (
      <div className={classes.container}>
        <Grid
          container
          className={classes.root}
          sx={{
            flexDirection: 'column',
          }}
        >
          <Grid className={classes.tools}>
            <RightPanelClose
              className={classes.iconStyle}
              onClick={() => setDetailsWindowOpen(false)}
            />
            <Delete
              className={classes.iconStyle}
              onClick={() => {
                setDeletePopUpOpen(true);
              }}
            />
          </Grid>
          <Grid className={classes.flex}>
            <Typography
              fontSize="14px"
              lineHeight="24px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {constants.ticketId}
            </Typography>
            <Typography
              fontSize="14px"
              lineHeight="24px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              {ticketId}
            </Typography>
          </Grid>
          <PageTitleAndSubTitle
            title={ticketDetails?.topic}
            subTitle={''}
            subTitleStyles={{ width: '0px' }}
          />
          <Divider
            style={{ backgroundColor: patientAccessTheme.palette.grey[300] }}
          />
          <Grid className={classes.scroll} style={{ paddingRight: '20px' }}>
            <Grid>
              <Typography
                fontSize="12px"
                lineHeight="17px"
                fontType="medium"
                textColor={patientAccessTheme.palette.text.highemphasis}
                margin="0px 0px 15px 0px"
              >
                {constants.description}
              </Typography>
              {isDescEditing ? (
                <Grid
                  className={classes.flex}
                  style={{ flexDirection: 'column', marginBottom: '20px' }}
                >
                  <TextField
                    width="495px"
                    onChange={(e: any) =>
                      handleChange(e, constants.description)
                    }
                    value={data.description}
                    multiline
                    inputPropsStyle={{
                      fontSize: '12px',
                      color: patientAccessTheme.palette.text.highemphasis,
                    }}
                  />
                  <Grid className={classes.flex}>
                    <Button
                      label={
                        <Typography
                          textColor={patientAccessTheme.palette.primary[500]}
                          fontSize="12px"
                          lineHeight="12px"
                          fontType={'medium'}
                        >
                          {constants.cancel}
                        </Typography>
                      }
                      variant="outlined"
                      height="36px"
                      width="60px"
                      borderRadius="4px"
                      onClick={() => handleCancel(constants.description)}
                    />
                    <Button
                      label={
                        <Typography
                          textColor={patientAccessTheme.palette.status.white}
                          fontSize="12px"
                          lineHeight="12px"
                          fontType={'medium'}
                        >
                          {constants.save}
                        </Typography>
                      }
                      variant="contained"
                      color="primary"
                      height="36px"
                      width="60px"
                      borderRadius="4px"
                      onClick={() => {
                        handleSave(ticketId, data);
                        setIsDescEditing(false);
                      }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  className={classes.desc}
                  onClick={() => setIsDescEditing(true)}
                >
                  <Typography
                    style={{
                      fontSize: '12px',
                      fontWeight: '500',
                      lineHeight: '17px',
                      whiteSpace: 'pre-wrap',
                      color: patientAccessTheme.palette.text.mediumemphasis,
                    }}
                  >
                    {data.description}
                  </Typography>
                </Grid>
              )}
            </Grid>
            <GeneralCardComponent
              title={constants.details}
              titleRightMostItem={
                isDetailsEditing ? (
                  <Grid className={classes.flex}>
                    <Button
                      label={
                        <Typography
                          textColor={patientAccessTheme.palette.primary[500]}
                          fontSize="12px"
                          lineHeight="12px"
                          fontType={'medium'}
                        >
                          {constants.cancel}
                        </Typography>
                      }
                      variant="outlined"
                      height="36px"
                      width="60px"
                      borderRadius="4px"
                      onClick={() => handleCancel(constants.details)}
                    />
                    <Button
                      label={
                        <Typography
                          textColor={patientAccessTheme.palette.status.white}
                          fontSize="12px"
                          lineHeight="12px"
                          fontType={'medium'}
                        >
                          {constants.save}
                        </Typography>
                      }
                      variant="contained"
                      color="primary"
                      height="36px"
                      width="60px"
                      borderRadius="4px"
                      onClick={() => {
                        handleSave(ticketId, data);
                        setIsDetailsEditing(false);
                      }}
                    />
                  </Grid>
                ) : (
                  <Grid
                    className={classes.flex}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setIsDetailsEditing(true)}
                  >
                    <Typography
                      fontSize="16px"
                      lineHeight="22px"
                      fontType="medium"
                      textColor={patientAccessTheme.palette.primary[500]}
                    >
                      {constants.edit}
                    </Typography>
                    <Edit stroke={patientAccessTheme.palette.primary[500]} />
                  </Grid>
                )
              }
              headerStyles={{
                justifyContent: 'center',
                backgroundColor: patientAccessTheme.palette.status.white,
                borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
              }}
              bodyStyles={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
              body={
                isDetailsEditing ? (
                  <Grid className={classes.flex} style={{ flexWrap: 'wrap' }}>
                    <ReportCreateNewLabelField
                      label={constants.type}
                      component={
                        <TypableDropdown
                          dropDownOptions={constants.TypeOptions}
                          dropDownValues={constants.TypeOptions}
                          placeholder={constants.type}
                          value={data.type}
                          handleChange={(event) => {
                            handleChange(event, constants.type);
                          }}
                          handleInputChange={(value) =>
                            setData((prevData) => ({
                              ...prevData,
                              type: value,
                            }))
                          }
                          textFieldPlaceholder="Enter Type here (or) select from below"
                          height="36px"
                          width="205px"
                          error={!data.type}
                        />
                      }
                      marginBottom="12px"
                    />
                    <ReportCreateNewLabelField
                      label={constants.platform}
                      component={
                        <Dropdown
                          label={constants.platform}
                          dropDownOptions={constants.platformOptions}
                          dropDownValues={constants.platformOptions}
                          value={data.platform}
                          setValue={(value: string) =>
                            setData((prevData) => ({
                              ...prevData,
                              platform: value,
                            }))
                          }
                          selectStyles={{
                            ...commonDropDownProps.selectStyles,
                            width: '230px',
                          }}
                          labelTop="10px"
                          onChange={(event: any) =>
                            handleChange(event, constants.platform)
                          }
                          error={!data.platform}
                        />
                      }
                      marginBottom="12px"
                    />

                    <ReportCreateNewLabelField
                      label={constants.priority}
                      component={
                        <Dropdown
                          label={constants.priority}
                          dropDownOptions={constants.priorityOptions}
                          dropDownValues={constants.priorityValues}
                          value={data.priority}
                          setValue={(value: string) =>
                            setData((prevData) => ({
                              ...prevData,
                              priority: value,
                            }))
                          }
                          selectStyles={{
                            ...commonDropDownProps.selectStyles,
                            width: '205px',
                          }}
                          labelTop="10px"
                          onChange={(event: any) =>
                            handleChange(event, constants.priority)
                          }
                          error={!data.priority}
                        />
                      }
                    />
                    {role === UserAccessConstants.SUPER_ADMIN && (
                      <>
                        <ReportCreateNewLabelField
                          label={constants.status}
                          component={
                            <Dropdown
                              label={constants.status}
                              dropDownOptions={constants.statusOptions}
                              dropDownValues={constants.statusValues}
                              value={data.status ?? ''}
                              setValue={(value: string) =>
                                setData((prevData) => ({
                                  ...prevData,
                                  status: value,
                                }))
                              }
                              selectStyles={{
                                ...commonDropDownProps.selectStyles,
                                width: '230px',
                              }}
                              labelTop="10px"
                              onChange={(event: any) =>
                                handleChange(event, constants.status)
                              }
                              error={!data.status}
                            />
                          }
                        />
                        <ReportCreateNewLabelField
                          label={constants.dueDate}
                          component={
                            <DatePicker
                              width="205px"
                              handleChange={handleDueDateChange}
                              selectedDate={formatDate(
                                data.dueDate,
                                'MMMM D, YYYY',
                              )}
                              minDate={moment()}
                              maxDate={moment().add(1, 'years')}
                              format={'MMMM d, yyyy'}
                              placeholder={constants.dueDateFormat}
                            />
                          }
                        />
                        <ReportCreateNewLabelField
                          label={constants.assignee}
                          component={
                            <Dropdown
                              label={constants.assignee}
                              dropDownOptions={assigneeOptions}
                              dropDownValues={assigneeValues}
                              value={data.assignee}
                              setValue={(value: string) =>
                                setData((prevData) => ({
                                  ...prevData,
                                  assignee: value,
                                }))
                              }
                              selectStyles={{
                                ...commonDropDownProps.selectStyles,
                                width: '230px',
                              }}
                              labelTop="10px"
                              onChange={(event: any) =>
                                handleChange(event, constants.assignee)
                              }
                            />
                          }
                        />
                      </>
                    )}
                  </Grid>
                ) : (
                  <>
                    <LabelValue
                      label={constants.platform}
                      value={ticketDetails?.platform}
                      labelsMinWidth="100px"
                    />
                    <LabelValue
                      label={constants.type}
                      value={ticketDetails?.type}
                      labelsMinWidth="100px"
                    />
                    <LabelValue
                      label={constants.createdBy}
                      value={
                        ticketDetails?.createdBy ? (
                          getAvatarComponent(
                            ticketDetails?.createdBy?.email,
                            ticketDetails?.createdBy?.firstName,
                            ticketDetails?.createdBy?.lastName,
                          )
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              gap: '5px',
                              alignItems: 'center',
                            }}
                          >
                            <AvatarEmpty />
                            None
                          </div>
                        )
                      }
                      labelsMinWidth="100px"
                    />
                    <LabelValue
                      label={constants.status}
                      value={getChipComponent(ticketDetails?.status)}
                      labelsMinWidth="100px"
                    />
                    <LabelValue
                      label={constants.dueDate}
                      value={
                        ticketDetails?.dueDate
                          ? moment(ticketDetails?.dueDate)
                              .utc()
                              .format(constants.dueDateFormat)
                          : '-'
                      }
                      labelsMinWidth="100px"
                    />
                    <LabelValue
                      label={constants.priority}
                      value={getPriorityIcon(ticketDetails?.priority, true)}
                      labelsMinWidth="100px"
                    />
                    {role === UserAccessConstants.SUPER_ADMIN && (
                      <LabelValue
                        label={constants.assignee}
                        value={
                          ticketDetails?.assigneeId ? (
                            getAvatarComponent(
                              ticketDetails?.assigneeId?.email,
                              ticketDetails?.assigneeId?.firstName,
                              ticketDetails?.assigneeId?.lastName,
                            )
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                              }}
                            >
                              <AvatarEmpty />
                              None
                            </div>
                          )
                        }
                        labelsMinWidth="100px"
                      />
                    )}
                  </>
                )
              }
              titleFontSize="12px"
              titleFontType="medium"
              mainGridStyles={{ marginBottom: '20px' }}
            />
            <GeneralCardComponent
              title={constants.comments}
              titleFontSize="12px"
              titleFontType="medium"
              headerStyles={{
                backgroundColor: patientAccessTheme.palette.status.white,
                borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
              }}
              bodyStyles={{
                maxHeight: '250px',
                paddingRight: '0px',
              }}
              body={
                <Grid
                  container
                  className={classes.scroll}
                  style={{
                    gap: '15px',
                    maxHeight: '210px',
                    flexWrap: 'nowrap',
                  }}
                  sx={{
                    flexDirection: 'column',
                  }}
                >
                  {comments.length > 0 &&
                    comments.map((item: any) => (
                      <Grid
                        key={item.commentId}
                        style={{
                          display: 'flex',
                          justifyContent:
                            (item?.commentedBy?.id ??
                              item?.careNavigatorCommentedBy?.cnId) ===
                            loginPageStore.userId
                              ? 'right'
                              : 'left',
                          paddingRight: '20px',
                          gap: '5px',
                        }}
                      >
                        {(item?.commentedBy?.id ??
                          item?.careNavigatorCommentedBy?.cnId) ===
                        loginPageStore.userId ? (
                          <>
                            <BasicFlex
                              layoutStyles={{
                                width: 'fit-content',
                                height: 'fit-content',
                                padding: '7px',
                                borderTopLeftRadius: '5px',
                                margin: '5px',
                              }}
                              body={
                                <Typography
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    lineHeight: '17px',
                                    whiteSpace: 'pre-wrap',
                                    color:
                                      patientAccessTheme.palette.text
                                        .mediumemphasis,
                                  }}
                                >
                                  {item.commentText}
                                </Typography>
                              }
                            />
                            {getAvatarIcon(
                              item?.commentedBy?.email ??
                                item?.careNavigatorCommentedBy?.email,
                              item?.commentedBy?.firstName ??
                                item?.careNavigatorCommentedBy?.firstName,
                            )}
                          </>
                        ) : (
                          <>
                            {getAvatarIcon(
                              item?.commentedBy?.email ??
                                item?.careNavigatorCommentedBy?.email,
                              item?.commentedBy?.firstName ??
                                item?.careNavigatorCommentedBy?.firstName,
                              role !== UserAccessConstants.SUPER_ADMIN,
                            )}
                            <BasicFlex
                              layoutStyles={{
                                width: 'fit-content',
                                height: 'fit-content',
                                padding: '7px',
                                borderTopRightRadius: '5px',
                                margin: '5px',
                              }}
                              body={
                                <Typography
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    lineHeight: '17px',
                                    whiteSpace: 'pre-wrap',
                                    color:
                                      patientAccessTheme.palette.text
                                        .mediumemphasis,
                                  }}
                                >
                                  {item.commentText}
                                </Typography>
                              }
                            />
                          </>
                        )}
                      </Grid>
                    ))}
                </Grid>
              }
              footer={
                <>
                  {getAvatarIcon(
                    loginPageStore.email,
                    loginPageStore.firstName,
                  )}
                  <TextField
                    placeholder={constants.commentsPlaceholder}
                    width="420px"
                    onChange={(e: any) => setNewComment(e.target.value)}
                    value={newComment}
                    inputPropsStyle={{ minHeight: '45px' }}
                    endAdornment={
                      isSending ? (
                        <Typography
                          fontSize="9px"
                          lineHeight="12px"
                          fontType="medium"
                          textColor={
                            patientAccessTheme.palette.text.mediumemphasis
                          }
                        >
                          {constants.sending}
                        </Typography>
                      ) : (
                        <Send
                          onClick={() => {
                            addNewComment();
                            setIsSending(true);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      )
                    }
                    onKeyDown={(e: any) => {
                      if (e.key === 'Enter') {
                        addNewComment(); // Trigger the send function when Enter is pressed
                        setIsSending(true);
                      }
                    }}
                  />
                </>
              }
            />
            <GeneralCardComponent
              title={constants.attachments}
              titleFontSize="12px"
              titleFontType="medium"
              titleColor={patientAccessTheme.palette.text.mediumemphasis}
              titleRightMostItem={
                <>
                  <Button
                    label={
                      <Typography
                        textColor={patientAccessTheme.palette.primary[500]}
                        fontSize="12px"
                        lineHeight="12px"
                        fontType={'medium'}
                      >
                        {isUploading ? constants.uploading : constants.upload}
                      </Typography>
                    }
                    startIcon={
                      isUploading ? (
                        <Processing
                          stroke={patientAccessTheme.palette.primary[500]}
                        />
                      ) : (
                        <Upload
                          stroke={patientAccessTheme.palette.primary[500]}
                        />
                      )
                    }
                    variant={'outlined'}
                    color="primary"
                    height="36px"
                    width={'fit-content'}
                    borderRadius="4px"
                    onClick={handleButtonClick}
                    disabled={isUploading}
                  />
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                </>
              }
              headerStyles={{
                backgroundColor: patientAccessTheme.palette.status.white,
                height: '76px',
                justifyContent: 'center',
              }}
              bodyStyles={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                paddingTop: '0px',
              }}
              body={
                <>
                  {attachments.map((item: any) => (
                    <UploadedDocument
                      name={item.fileName}
                      size={item.fileSize}
                      startIcon={
                        <FilePresent
                          stroke={patientAccessTheme.palette.primary[500]}
                          fill={patientAccessTheme.palette.primary[500]}
                        />
                      }
                      handleDelete={() => {
                        deleteAttachment(item.attachmentId);
                      }}
                      handleOnClick={() => handleDownload(item)}
                    />
                  ))}
                </>
              }
              mainGridStyles={{ border: '0px' }}
            />
          </Grid>
        </Grid>
      </div>
    );
  },
);

export default TicketDetailsWindow;
